
export default function SectionHeader({children}) {
  return (
    <h1 className="lg:text-5xl md:text-4xl text-3xl leading-loose max-w-[600px] mb-10 text-accent">{children}</h1>
  )
}
